import { combineReducers } from 'redux';
import login from './login';
import menuAccess from './menuAccess';
import setUserMenuAccess from './setUserMenuAccess';
import sidebarMenuCount from './sidebarMenuCount';

export default combineReducers({
  login,
  menuAccess,
  setUserMenuAccess,
  sidebarMenuCount,
});
